export var BucketNotificationTransport;
(function (BucketNotificationTransport) {
    BucketNotificationTransport["BUCKET_NOTIFICATION_TRANSPORT_SQS"] = "SQS";
    BucketNotificationTransport["BUCKET_NOTIFICATION_TRANSPORT_EVENTBRIDGE_SQS"] = "EVENTBRIDGE_SQS";
    BucketNotificationTransport["BUCKET_NOTIFICATION_TRANSPORT_PUBSUB"] = "PUBSUB";
    BucketNotificationTransport["BUCKET_NOTIFICATION_TRANSPORT_KAFKA"] = "KAFKA";
})(BucketNotificationTransport || (BucketNotificationTransport = {}));
